var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['round-loader-container', _vm.transparentBackground ? 'round-loader-container_bg-transparent' : '']},[_c('Loader',{style:(`scale: ${_vm.scale}`)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }